import React from 'react'
import { Box } from '@mui/material'
import lang from '@/lang'
import { withAsyncData } from '@/utils/withAsyncData'
import { useAppSelector } from '@/redux/store'
import Loader from '@/modules/base/components/loader/loader-inline'
import Topbar from '@/modules/base/components/topbar/topbar'
import AppForm from './app-form/index'
import FeatureLockedNotice from '@/modules/base/components/modal/upgrade-modal/feature-locked/feature-locked-notice'
import { FeatureTypes } from '@/modules/base/components/modal/upgrade-modal/feature-locked/feature-config'
import { PATH_PUBLISHED } from './apps-list'

const AppNew = () => {
  const { loading, hasPublicApiAccess } = useAppSelector(state => state.subscription.details)

  if (loading) {
    return <Box height={200}><Loader /></Box>
  }

  if (hasPublicApiAccess) {
    return <AppForm />
  }

  return (
    <>
      <Topbar title={lang.marketplace.form.toolbar(false)} backButtonUrl={`/apps/${PATH_PUBLISHED}`} />
      <Box p={4}>
        <FeatureLockedNotice featureType={FeatureTypes.PUBLIC_API} />
      </Box>
    </>
  )
}

export default withAsyncData(AppNew, 'AppNew')
